import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'
import { Icon } from '@/common/components/Icon'

const pillVariants = cva(
  'flex items-center gap-2.5 rounded-2xl border px-[15px] py-2.5 text-sm font-semibold leading-6 text-monochrome-1',
  {
    variants: {
      variant: {
        warning: 'border-accent-4 bg-monochrome-3-60',
      },
    },
    defaultVariants: {
      variant: 'warning',
    },
  },
)

export interface PillProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof pillVariants> {
  icon?: boolean
}

const Pill = React.forwardRef<HTMLDivElement, PillProps>(
  ({ className, variant, icon = true, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(pillVariants({ variant }), className)}
        {...props}
      >
        {icon && (
          <Icon
            icon="warning-2"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="bg-accent-4"
            className="shrink-0"
          />
        )}
        <span className="min-w-0 flex-1">{children}</span>
      </div>
    )
  },
)
Pill.displayName = 'Pill'

export { Pill, pillVariants }
